import { render } from "./ThankYouPopupCms.vue?vue&type=template&id=2a294608"
import script from "../js/thank-you-popup-cms.js?vue&type=script&lang=js"
export * from "../js/thank-you-popup-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__